import React, { useState, useEffect } from 'react';
import SuperAdminLogin from './SuperAdminLogin';
import SuperAdminDashboard from './SuperAdminDashboard';

// Returns false for malformed tokens or tokens past their exp claim, so we
// never mount the dashboard with a token the backend will reject.
const isTokenUsable = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return !payload.exp || payload.exp * 1000 > Date.now();
  } catch (error) {
    return false;
  }
};

const SuperAdminApp = () => {
  const [superAdmin, setSuperAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if super admin is already logged in
    const token = localStorage.getItem('super_admin_token');
    const adminInfo = localStorage.getItem('super_admin_info');

    if (token && adminInfo && isTokenUsable(token)) {
      try {
        setSuperAdmin(JSON.parse(adminInfo));
      } catch (error) {
        console.error('Failed to parse super admin info:', error);
        localStorage.removeItem('super_admin_token');
        localStorage.removeItem('super_admin_info');
      }
    } else if (token || adminInfo) {
      // Expired or malformed session — clear it so we land on the login form.
      localStorage.removeItem('super_admin_token');
      localStorage.removeItem('super_admin_info');
    }

    setLoading(false);
  }, []);

  const handleLogin = (adminData) => {
    setSuperAdmin(adminData);
  };

  const handleLogout = () => {
    localStorage.removeItem('super_admin_token');
    localStorage.removeItem('super_admin_info');
    setSuperAdmin(null);
  };

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '3px solid rgba(255,255,255,0.3)',
          borderRadius: '50%',
          borderTopColor: 'white',
          animation: 'spin 1s ease-in-out infinite'
        }}></div>
        <style>
          {`
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  }

  if (!superAdmin) {
    return <SuperAdminLogin onLogin={handleLogin} />;
  }

  return <SuperAdminDashboard superAdmin={superAdmin} onLogout={handleLogout} />;
};

export default SuperAdminApp;